import {JSX} from "react";

import {Typography} from "@/shared/ui/data-display/typography";
import {FontWeight, ResponsiveSize} from "@/shared/ui/data-display/typography/typography";
import {ContainerBase} from "@/shared/ui/layout/container-base";

interface Props {
    children?: string;

    size?: ResponsiveSize;
    weight?: FontWeight;
    className?: string;
}
const SIZE_DEFAULT: ResponsiveSize = {desktop: 32, mobile: 20};
export function VideoTestimonialsTitle({children, size = SIZE_DEFAULT, weight = 500, className}: Props): JSX.Element {
    const rootClassName = className ? `video-testimonials__title ${className}` : "video-testimonials__title";

    return (
        <div className={rootClassName}>
            <ContainerBase>
                <Typography
                    className="video-testimonials__title-h"
                    as="h2"
                    lineHeight={120}
                    size={size}
                    weight={weight}
                    color="black"
                    innerHTML={children}
                />
            </ContainerBase>
        </div>
    );
}
